module.exports = __webpack_public_path__ + "img/header.3f996c16.png";